'use client';

import { motion } from 'framer-motion';
import { BRAND_COLORS } from '@/constants';

const ContactUsSection = ({ dict }: { dict: any }) => {
  const contactOptions = [
    {
      id: 1,
      title: dict.contact_askExpert || 'Ask an Expert',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"/>
        </svg>
      ),
      href: '#',
    },
    {
      id: 2,
      title: dict.contact_caregiverTool || 'Caregiver Tech Tool Finder',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
        </svg>
      ),
      href: '#',
    },
    {
      id: 3,
      title: dict.contact_newsletter || 'Sign Up for our Newsletter',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
        </svg>
      ),
      href: '#',
    },
    {
      id: 4,
      title: dict.contact_upcomingEvents || 'View Upcoming Events',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"/>
        </svg>
      ),
      href: '#',
    },
    {
      id: 5,
      title: dict.contact_partner || 'Partner with Us',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M16 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm4 18v-6h2.5l-2.54-7.63A1.5 1.5 0 0 0 18.54 8H17c-.8 0-1.54.37-2.01.97L14 10.5l-.99-1.53C12.54 8.37 11.8 8 11 8H9.46c-.8 0-1.54.37-2.01.97L5 10.5l-.99-1.53C3.54 8.37 2.8 8 2 8H.5L3 15.5V22h2v-6h2.5L5.5 22H8l2.5-6H13v6h2v-6h2.5L18.5 22H21l2.5-6H24v6h2z"/>
        </svg>
      ),
      href: '#',
    },
    {
      id: 6,
      title: dict.contact_donate || 'Donate to Our Support Mission',
      icon: (
        <svg className="w-6 h-6" fill="currentColor" viewBox="0 0 24 24">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
        </svg>
      ),
      href: '#',
    },
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <motion.p
            className="font-semibold uppercase tracking-wide mb-2"
            style={{ color: BRAND_COLORS.PRIMARY_BLUE, fontSize: '15px' }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            {dict.contact_badge || 'CONTACT US'}
          </motion.p>
          <motion.h2
            className="font-extrabold programs-title-dark"
            style={{ fontSize: '37px' }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            viewport={{ once: true }}
          >
            {dict.contact_title || 'Stay Connected'}
          </motion.h2>
        </div>

        {/* Main Content */}
        <div className="flex justify-center">
          <div className="relative flex items-center gap-[20px]">
            {/* left image card — exact picture specs */}
            <div className="rounded-[50px] overflow-hidden shadow-2xl h-[658px] w-[786px]">
              <img
                src="/images/realImages/contactus-image.png"
                alt={dict.contact_imageAlt || 'Two people connecting'}
                className="h-full w-full object-cover"
              />
            </div>

            {/* right box — exact box specs & overlap */}
            <motion.div
              className="relative z-10 bg-[#1E3A8A] rounded-[40px] h-[528px] w-[596px] p-[30px] flex items-center"
              style={{ marginLeft: '-120px' }} // pulls over the image; tweak to taste
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
            >
              <div className="w-full">
                <div className="space-y-[10px]">
                  {contactOptions.map((option, index) => (
                    <motion.a
                      key={option.id}
                      href={option.href}
                      className="flex items-center justify-between rounded-lg px-3 py-3 transition-all duration-200 hover:bg-white/10 group"
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.6, delay: index * 0.1 }}
                      viewport={{ once: true }}
                    >
                      <div className="flex items-center gap-4">
                        <span className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center text-white group-hover:bg-white/30">
                          {option.icon}
                        </span>
                        <h3 className="text-base font-semibold text-white">
                          {option.title}
                        </h3>
                      </div>
                      <svg
                        className="w-4 h-4 text-white opacity-0 group-hover:opacity-100 transition-opacity"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                      </svg>
                    </motion.a>
                  ))}
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUsSection;
